import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ActionMenuComponent } from '../../../../shared/components/action-menu/action-menu.component';
import { Blog } from '../../../../shared/models/blog.model';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-blog',
  standalone: true,
  imports: [SharedModule, ActionMenuComponent],
  templateUrl: './blog.component.html',
  styleUrl: './blog.component.scss',
})
export class BlogComponent implements OnInit {
  @Input() blog!: Blog;
  @Input() index!: number;
  @Input() lastElement: boolean = false;
  @Input() menuOpenIndex: number = -1;

  @Output() openMenuEmitter: EventEmitter<void> = new EventEmitter();
  @Output() closeMenuEmitter: EventEmitter<void> = new EventEmitter();
  @Output() onDeleteBlogEmitter: EventEmitter<string> = new EventEmitter();
  @Output() loadMoreIfLastIndexEmitter: EventEmitter<void> = new EventEmitter();

  readTime = 0;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.readTime = this.getReadTime(this.blog.content);
  }
  openMenu() {
    this.openMenuEmitter.emit();
  }

  closeAllMenu() {
    this.closeMenuEmitter.emit();
  }

  onDeleteBlog() {
    this.onDeleteBlogEmitter.emit(this.blog.id);
  }

  loadMoreIfLastIndex() {
    this.loadMoreIfLastIndexEmitter.emit();
  }
  getReadTime(text: string) {
    const wpm = 225;
    const words = text.trim().split(/\s+/).length;
    return Math.ceil(words / wpm);
  }

  handleEditBlog(id: string | number) {
    this.router.navigate(['/edit-blog/' + id]);
  }
}
